import Vue from 'vue'
import { VuePlugin } from 'vuera'
import App from './App.vue'
import {qs} from './utils/qs.js'
import VueAxios from 'vue-axios'
import { securedAxiosInstance, plainAxiosInstance } from './backend/axios'
import filters from './filters';
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Toast from "vue-toastification";
import Ably from 'ably';

const ably = new Ably.Realtime({key: process.env.VUE_APP_ABLY_KEY})

const ablyChannel = ably.channels.get(`attendee:${qs['tid']}`)

import './scss/style.scss';

library.add(faChevronDown, faChevronUp)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VuePlugin)

Vue.use(Toast, {
  position: "top-center",
  timeout: false,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
});

Vue.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance
})
Vue.config.productionTip = false

import _ from 'lodash'
Vue.set(Vue.prototype, '_', _)

Vue.use(filters);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentTime: qs['time'] ? new Date(qs['time']) : new Date(),
    isLoading: true,
    event: {name: "", event_guide_embed_code: ""},
    attendee: {},
    chat: null,
    $axios: securedAxiosInstance,
    ablyChannel: ablyChannel,
    notifications: [],
    delegateInformation: null
  },
  mutations: {
    updateCurrentTime (state) {
      if (qs['time']) {
        state.currentTime = new Date(state.currentTime.getTime() + 1000)
      } else {
        state.currentTime = new Date()
      }
    },
    loaded (state) {
      state.isLoading = false
    },
    loading (state) {
      state.isLoading = true
    },
    setEvent (state, event) {
      state.event = event
    },
    setAttendee (state, attendee) {
      state.attendee = attendee
    },
    setChat (state, chat) {
      state.chat = chat
    },
    addNotification (state, notification) {
      state.notifications.unshift(notification)
    },
    setNotifications (state, notifications) {
      state.notifications = notifications
    },
    markNotificationsAsRead(state, ids) {
      ids = ids.filter(Boolean)
      if (!Array.isArray(ids) || ids.length === 0) { return }

      state.$axios.post('/attendee_api/v1/notifications/mark_as_read', {ids})
      state.notifications = state.notifications.map((notification) => {
        if (ids.includes(notification.id)) {
          return window.jQuery.extend({}, notification, {read: true})
        } else {
          return notification
        }
      })
    },
    setDelegateInformation(state, delegateInformation) {
      state.delegateInformation = delegateInformation
    },
  },
  actions: {
    async fetchEvent ({ commit }) {
      commit('setEvent', (await this.state.$axios.get('/attendee_api/v1/event')).data)
    }
  }
})

window.jQuery.fancybox.defaults.smallBtn=true
window.jQuery.fancybox.defaults.iframe.css = {width: '100%'}

new Vue({
  render: h => h(App),
  store,
  securedAxiosInstance,
  plainAxiosInstance,
  router,
  created() {
    let self = this;
    setInterval(() => {
      self.$store.commit("updateCurrentTime")
    }, 1000)
  },
  mounted() {
  },
}).$mount('#app')
